import { Input, Button } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import { useEffect, useState } from "react";
import { EditFileNoteApi, GetFileNoteApi } from "../../../api/request/service";
import Spinner from "../../../components/loader/Spinner";
import toast from "react-hot-toast";
import LoadableButton from "../../../components/button/LoadableButton";

const FileNotesModal = ({
  isOpen,
  setIsOpen,
  task,
  selectedFile,
}) => {
  const { TextArea } = Input;
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isNoteLoading, setIsNoteLoading] = useState(false);
  const [updateNote, setUpdateNote] = useState("");


  const getFileNotes = async () => {
    try {
      setIsLoading(true);
      const params = {
        file_id: selectedFile?.id,
        task_id: task?.id,
      };
      const { data } = await GetFileNoteApi(params);
      if (data?.status) {
        setNote(data?.data || "");
        setUpdateNote(data?.data?.notes || "");
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateNote = async () => {
    try {
      setIsNoteLoading(true);
      const params = {
        file_id: selectedFile?.id,
        task_id: task?.id,
        notes: updateNote,
        id: note?.id,
      };
      const { data } = await EditFileNoteApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsNoteLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) getFileNotes();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setNote("");
      setUpdateNote("");
    }
  }, [isOpen]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Edit File Notes"
      footer={null}
    >
      {isLoading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (
        <TextArea
          rows={3}
          style={{ width: "100%" }}
          value={updateNote}
          onChange={(e) => setUpdateNote(e.target.value)}
        />
      )}
      <div className="text-center mt-5">
        <LoadableButton
          lable={"Update Note"}
          onClick={handleUpdateNote}
          disabled={updateNote === note?.notes}
          isLoading={isNoteLoading}
        />
      </div>
    </ModalComponent>
  );
};

export default FileNotesModal;
